<template>
  <section class="Videos" id="Videos">
    <div class="videos_wrapper">
      <div class="title_wrapper">
        <h1 class="title light">
          Videos
        </h1>
      </div>
      <div v-if="!videosList.length" class="empty_videos">
        <div class="empty_videos_wrapper">
          <div class="square">
          </div>
          <p>
            No se encontraron imagenes
          </p>
        </div>
      </div>
      <div v-show="videosList.length" class="videos_list">
        <div class="swiper-container videos">
          <div class="swiper-wrapper">
            <article class="swiper-slide video" v-for="video in videosList" :key="video.id" @click="selectVideo(video.url)">
              <div class="play_button_overlay">
                <div class="play_button">
                  <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 15 17" fill="none">
                    <path d="M15 8.55909L0.450607 16.5774L0.450608 0.540815L15 8.55909Z"  fill="#34498B"/>
                  </svg>
                </div>
              </div>
              <img loading="lazy" :src="'https://img.youtube.com/vi/'+getVideoId(video.url)+'/mqdefault.jpg'" />
            </article>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.min.css'
import { firestore } from '@/main'
Swiper.use([Navigation, Pagination])

export default {
  name: "videos",
  data: () => ({
    videosList: [],
    offsetStart: 0,
    mySwiper: null
  }),
  mounted () {
    this.getOffset()
    this.getAllvideos()
    this.mySwiper = new Swiper('.swiper-container.videos', {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesOffsetBefore: this.offsetStart,
      slidesOffsetAfter: this.offsetStart,
      observer: true,
      observeParents: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 25,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        400: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        760: {
          slidesPerView: 3,
        },
        980: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 5,
        },
      }
    })
  },
  methods: {
    selectVideo(url) {
      this.$emit("selectVideo", url)
    },
    getAllvideos() {
      // let first = null
      firestore
        .collection('videos')
        .orderBy('initial', 'desc')
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            const data = doc.data()
            // if (data.initial) {
            //   first = data
            // }else {
              this.videosList.push({
                id: doc.id,
                url: data.url,
                initial: data.initial
              })
            // }
          })
          // if (first) this.videosList.unshift(first)
        })
        .catch(console.error)
    },
    getOffset () {
      const title = document.querySelector('#objectives_title')
      this.offsetStart = title.getBoundingClientRect().left
      window.addEventListener('resize', () => {
        if (window.innerWidth > 760) {
          this.mySwiper.params.slidesOffsetBefore = title.getBoundingClientRect().left
          this.mySwiper.params.slidesOffsetAfter = title.getBoundingClientRect().left
        }
      })
    },
    getVideoId (url) {
      console.log('url', url)
      const code = url.match(/v=([^&#]{5,})/)
      return (typeof code[1] == 'string') ? code[1] : false;
    }
  },
}
</script>

<style lang="sass" scoped>
@import '../assets/css/app.sass'
.Videos
  background-color: rgba($primary_color, .03)
  height: 650px
  overflow: hidden
  .videos_wrapper
    opacity: 1
    transition: all ease-in-out .5s .5s
    position: relative
    .square
      height: 20px
      width: 20px
      margin-left: -30px
      background-color: $accent_color
      position: relative
      &:before
        position: relative
        content: ''
        display: block
        right: -20px
        bottom: -20px
        width: 20px
        height: 20px
        background-color: $secondary_color
    .empty_videos
      display: flex
      justify-content: center
      align-items: center
      .empty_videos_wrapper
        display: flex
        flex-direction: column
        align-items: center
        margin-top: 12rem
        p
          margin-top: 50px
          color: #546397
          font-family: $font
          width: 200px
          text-align: center
          line-height: 1.6
          font-size: 13px
    .swiper-container
      overflow: inherit
    .title_wrapper
      display: flex
      justify-content: flex-start
      padding-left: 70px
      box-sizing: border-box
      width: 980px
      padding-top: 7rem
      margin: 0 auto
    .videos_list
      margin-top: 80px
      position: relative
      z-index: 20
      .more
        display: flex
        justify-content: center
        align-items: center
        background-color: #182a61
        color: white
        cursor: pointer
        transition: all ease-in-out .3s
        text-decoration: none
        &:hover
          background-color: $primary_light_color
        .plus
          width: 4px
          height: 20px
          background-color: #fff
          position: relative
          &:before
            content: ''
            position: absolute
            left: -8px
            top: 8px
            height: 4px
            width: 20px
            background-color: #fff
        p
         margin-top: 20px
         font-size: 14px
      .events
        left: 0
        top: 0
      article, a
        background-color: white
        box-sizing: border-box
        height: 300px
        font-family: $font
        color: $primary_color
        display: flex
        flex-direction: column
        cursor: pointer
        .play_button_overlay
          background-color: rgba($primary_color, .65)
          width: 100%
          height: 100%
          position: absolute
          left: 0
          top: 0
          display: flex
          justify-content: center
          align-items: center
          .play_button
            width: 40px
            height: 40px
            border-radius: 50%
            background-color: white
            display: flex
            justify-content: center
            align-items: center
            z-index: 3
            cursor: pointer
            svg
              width: 8px
        img
          width: 100%
          height: 100%
          object-fit: cover
          display: block
@media screen and (max-width: 980px)
  .Videos
    height: 420px
    .videos_wrapper
      .title_wrapper
        width: 760px
        padding-top: 5rem
      .videos_list
        margin-top: 50px
        article, a
          height: 200px

@media screen and (max-width: 760px)
  .Videos
    .videos_wrapper
      .title_wrapper
        width: 480px
        padding-left: 0

@media screen and (max-width: 560px)
  .Videos
    .videos_wrapper
      .title_wrapper
        width: 320px

@media screen and (max-width: 400px)
  .Videos
    .videos_wrapper
      width: 100%
      padding:
        left: 40px
        right: 40px
      box-sizing: border-box
      align-items: flex-start
      .title_wrapper
        width: 100%
        padding-left: 0
        justify-content: flex-start

</style>